import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton
} from '@coreui/react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import AddItemGallery from 'src/components/gallery/AddItemGallery';
import AxiosInstance from 'src/components/Axios';
import BasicModal from 'src/components/Modal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import GalleryList from 'src/components/gallery/GalleryList';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import LangugesPanel from './LangugesPanel';
import CreatableSelect from 'react-select/creatable';
import { transliterate } from 'transliteration';

export async function LoaderGalleryUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await AxiosInstance.get('/galleries/' + params.id).then((response) => {
      return response;
    });
    return res;
  }
  return false;
}
const formReducer = (state, event) => {
  return {
    ...state,
    [event.target.name]: event.target.value
  }
}
const GalleryForm = ({ user_data }) => {
  if (!Permissions(user_data, 'Gallery', 'EDIT_GALLERY')) {
    return <PermissionsNoPage />;
  }

  const { data } = useLoaderData();
  const defaultGalleryType = {"value":"Images","label":"Images"};
  const galleryTypes = process.env.REACT_APP_GAllERY_TYPE !== undefined ? JSON.parse(process.env.REACT_APP_GAllERY_TYPE) : [];
  const [selectedOption, setSelectedOption] = useState((data?.type != undefined) ? (galleryTypes.find(type => type.value === data.type) || {value: data.type, label: data.type}) : defaultGalleryType);

  const [name, setName] = useState((data != undefined) ? data.name : '');
  const [year, setYear] = useState((data?.year != undefined) ? data.year : 0);
  const [language, setLaguage] = useState((data != undefined) ? data.language?.key : 'ua');

  // const [newsShot, setNewsShot] = useState((data != undefined) ? data.newsShot : '');
  const editorRef = useRef(null);
  const navigate = useNavigate();
  const popup = MyToastify();


  useEffect(() => {
    if (data != undefined) {
      setName(data.name)
    }
  }, [data])

  const handleChangeOption = (selectedOption) => {
    if(selectedOption?.__isNew__){
      setSelectedOption({...selectedOption, value: transliterate(selectedOption.value).toLowerCase().replace(/ /g, '_')})
    }
    else {
      setSelectedOption(selectedOption);
    }
  };

  const handleSubmit = event => {
    event.preventDefault();

    const article = {
      name: name,
      year: year,
      type: selectedOption?.value !== undefined ? selectedOption.value : defaultGalleryType.value
      // newsShot: newsShot,
      // newsFull: editorRef.current.getContent(),
    };
    if (data != undefined) {
      article.language = data.language ? `/api/languages/${data.language.id}` : `/api/languages/1`;
      const response = AxiosInstance.put('/galleries/' + data.id, article).then((response) => {
        if (response.status == 200) {
          popup.toastifySuccess('Галерею оновлено');
          // navigate(`/gallery/update/${response.data.id}`);
        }
      }).catch((error) => {
        popup.toastifyWarning('Галерею не оновлено')
      });
    } else {
      article.language = `/api/languages/1`;
      const response = AxiosInstance.post('/galleries', article).then((response) => {
        // console.log(response);
        if (response.status == 201) {
          popup.toastifySuccess("Галерею створено")
          navigate(`/gallery/update/${response.data.id}`);
        }
      }).catch(e => {
        popup.toastifyWarning('Галерею не створено')
      });
    }
  }

  const [showModal, setShowModal] = useState(false);
  const [updateLists, setUpdateLists] = useState(true);

  const actionShowModal = (rez, isUpdate = false) => {
    setShowModal(rez);
    if (!rez && isUpdate)
      setUpdateLists(true);
  }

  return (
    <>
      <ToastContainer />
      <div className='col d-flex justify-content-end'>
        {data !== undefined &&
          <LangugesPanel data={data}
            // setMyData={setMyData}
            setLaguage={setLaguage}
            language={language} />}
      </div>
      <CForm onSubmit={handleSubmit}>
        <div className="mb-3 info-col">
          <div className='mb-3'>
            <CFormLabel htmlFor="exampleFormControlInput1">Назва галереї</CFormLabel>
            <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <CFormLabel htmlFor="exampleFormControlInput1">Рік створення</CFormLabel>
          <CFormInput type="number" id="exampleFormControlInput1" value={year} onChange={(e) => setYear(parseInt(e.target.value))} />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="select11">Тип галереї</CFormLabel>
          <CreatableSelect 
              isClearable 
              options={galleryTypes} 
              value={selectedOption}
              onChange={handleChangeOption}
            />
        </div>
        <CButton type="submit" color="success">Зберегти</CButton>
      </CForm>
      <hr />
      {(data !== undefined) &&
        <div className='row'>
          <div className='col-12'>
            <BasicModal
              show={showModal}
              actionShowModal={actionShowModal}
              title={`Додати  - ${data.name}`}
              btn_name={<>Додати об'єкт</>}
              content={
                <AddItemGallery toastifySuccess={popup.toastifySuccess} parent_id={data.id} actionShowModal={actionShowModal} gallery={data} />
              }
            />
          </div>
          <div className='col-12 mt-2'>
            <GalleryList gallery_id={data.id} updateLists={updateLists} setUpdateLists={setUpdateLists} gallery={data} />
          </div>
        </div>}
    </>
  );
};

export default GalleryForm;
